module.exports = __webpack_public_path__ + "img/dsci0048.cb413927.jpg";